import React, { useState } from "react";
import "./AchievementDropdown.css";

/**
 * A reusable accordion component for categorization.
 * @param {string} title - The title of the category.
 * @param {React.ReactNode} children - The rows/items within this category.
 * @param {boolean} defaultOpen - Whether the dropdown starts open.
 */
function AchievementDropdown({ title, children, defaultOpen = false }) {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    const toggle = () => setIsOpen((prev) => !prev);

    return (
        <div className={`achievement-dropdown ${isOpen ? "is-open" : ""}`}>
            <button 
                className="achievement-dropdown-header" 
                onClick={toggle}
                aria-expanded={isOpen}
            >
                <span className="dropdown-title">{title}</span>
                <span className="dropdown-icon">
                    <svg 
                        width="20" 
                        height="20" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        stroke="currentColor" 
                        strokeWidth="2.5" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                    >
                        <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                </span>
            </button>
            <div className="achievement-dropdown-content">
                <div className="dropdown-inner">
                    {children}
                </div>
            </div>
        </div>
    );
}

export default AchievementDropdown;
